import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface ConversationHeaderOverflowButtonProps {
  value: number;
  isExpanded: boolean;
  onClick?: () => void;
}

/*
 * Style.
 */

interface StyledExpandButtonProps {
  $isExpanded: boolean;
}

const StyledExpandButton = styled(ChromelessButton)<StyledExpandButtonProps>`
  ${(p) => styleExpandButtonState(p)};

  padding: 3px 5px;

  color: ${(p) => p.theme.greys.white};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.bold};
  line-height: 16px;

  background-color: ${(p) => p.theme.greys.shade70};
  border-radius: 3px;

  &:hover {
    background-color: ${(p) => p.theme.greys.shade80};
  }
`;

function styleExpandButtonState(props: StyledExpandButtonProps) {
  if (props.$isExpanded) {
    return css`
      position: absolute;
      bottom: 4px;
      right: 16px;
    `;
  }
  return css`
    position: relative;
    margin: 2px 6px 3px 0;
  `;
}

/*
 * Components.
 */

export const ConversationHeaderOverflowButton: FC<ConversationHeaderOverflowButtonProps> = (props) => {
  const {isExpanded, value, onClick} = props;
  const content = isExpanded ? <Icon name="chevronUpSmall" /> : `+${value}`;
  return (
    <StyledExpandButton $isExpanded={isExpanded} onClick={onClick}>
      {content}
    </StyledExpandButton>
  );
};
